import React, { ReactNode, CSSProperties, KeyboardEvent } from 'react'

interface CardProps {
	className?: string
	style?: CSSProperties
	children: ReactNode
	onClick?: () => void
	secondary?: boolean
	disabled?: boolean
}

const Card = ({ className = '', style, children, onClick, secondary = false, disabled = false }: CardProps) => {
	// TODO: change shadow
	const shapeStyles = secondary ? 'border-2 border-slate-100 shadow-sm rounded-md' : 'rounded-lg'
	const surfaceStyles = disabled ? 'bg-slate-100 text-slate-400' : secondary ? 'bg-slate-50' : 'bg-white'

	const isClickable = !!onClick && !disabled
	const cursorStyles = disabled ? 'cursor-not-allowed' : isClickable ? 'cursor-pointer' : 'cursor-auto'

	const handleKeyDown = (e: KeyboardEvent<HTMLDivElement>) => {
		if (isClickable && (e.key === 'Enter' || e.key === ' ')) {
			e.preventDefault()
			onClick?.()
		}
	}

	return (
		<div
			className={`h-fit w-fit ${shapeStyles} ${surfaceStyles} ${cursorStyles} ${className}`}
			style={{
				...(!secondary && { boxShadow: 'rgb(149 157 165 / 20%) 0px 8px 24px' }),
				...style
			}}
			onClick={isClickable ? onClick : undefined}
			role={isClickable ? 'button' : undefined}
			tabIndex={isClickable ? 0 : undefined}
			onKeyDown={handleKeyDown}
			aria-disabled={disabled || undefined}
		>
			{children}
		</div>
	)
}

export default Card
